import React from 'react';
import CategoryCardCollapsible from 'src/components/atomic/organisms/categoryCardCollapsible/CategoryCardCollapsible';
import CategoryCardCollapsibleSkeleton from 'src/components/atomic/molecules/categoryCardCollapsibleSkeleton/CategoryCardCollapsibleSkeleton';
import { SpendingSumModel } from 'src/types/spending-sum.model';
import styles from './categoryCardGrid.module.scss';
import { getBudgetForCategory } from 'src/utils/budget.utils';
import { BudgetModel } from 'src/types/budget.model';
import { CategoryModel } from 'src/types/category.model';
import H from 'history';
import Selectors from 'src/utils/selectors';

interface CategoryCardGridProps {
    familySpendingSums: SpendingSumModel[][];
    budgets: BudgetModel[];
    categories: CategoryModel[];
    history: H.History;
    isLoading?: boolean;
    isSyncingAccounts?: boolean;
    isMinWidthSmall?: boolean;
}

export default function CategoryCardGrid({
    familySpendingSums,
    budgets,
    categories,
    isLoading,
    isSyncingAccounts,
    isMinWidthSmall,
    history
}: CategoryCardGridProps): JSX.Element {
    if (isLoading || isSyncingAccounts) return <CategoryCardSkeletonGrid />;

    return (
        <div className={styles.categoryCardGrid} data-cy={Selectors.SpendSmart.CATEGORY_CARD_GRID}>
            {familySpendingSums?.map((spendingSum, index) => {
                const parentCategory = spendingSum[0];
                const subcategories = spendingSum.slice(1);
                const parentBudget = getBudgetForCategory(budgets, parentCategory.groupId);
                const subcategoryBudgets = subcategories.map((subcategory) =>
                    getBudgetForCategory(budgets, subcategory.groupId)
                );
                return (
                    <CategoryCardCollapsible
                        key={parentCategory.groupId}
                        parentCategory={parentCategory}
                        subcategories={subcategories}
                        parentBudget={parentBudget}
                        subcategoryBudgets={subcategoryBudgets}
                        categories={categories}
                        history={history}
                        isMinWidthSmall={isMinWidthSmall}
                        addBorder={index !== familySpendingSums.length - 1}
                    />
                );
            })}
        </div>
    );
}

export function CategoryCardSkeletonGrid(): JSX.Element {
    return (
        <div className={styles.categoryCardGridSkeleton} data-cy={Selectors.SpendSmart.CATEGORY_CARD_SKELETON_GRID}>
            <CategoryCardCollapsibleSkeleton />
            <CategoryCardCollapsibleSkeleton />
            <CategoryCardCollapsibleSkeleton />
            <CategoryCardCollapsibleSkeleton />
        </div>
    );
}
